import Error from '../../components/Errors/error.vue';
import NotFound from '../../components/Errors/404.vue';
import Login from '../../components/Login';
import ForgotPassword from '../../components/ForgotPassword';
import ResetPassword from '../../components/ResetPassword';
import Preferences from '../../components/Preferences';
import Notifications from '../../components/Notifications';
import Home from '../../components/Home';

import Agencies from '../../components/Agencies/Agencies';
import agenciesRoutes from '../Agencies';
import Clients from '../../components/Clients/Clients';
import clientsRoutes from '../Clients/index';
import Users from '../../components/Users/Users';
import usersRoutes from '../Users';
import AgencyOrders from '../../components/AgencyOrders/AgencyOrders';
import AgentOrderDashboard from '../../components/AgencyOrders/AgentOrders/Dashboard';
import AgentOrderMedia from '../../components/AgencyOrders/AgentOrders/OrderMedia';
import PropertyOrderDashboard from '../../components/AgencyOrders/PropertyOrders/Dashboard';
import OrderCampaignReport from '../../components/AgencyOrders/Public/CampaignReport';
import CampaignNewPdfReports from '../../components/AgencyOrders/Public/CampaignNewPdfReports';
import PropertyOrderMedia from '../../components/AgencyOrders/PropertyOrders/OrderMedia';
import Campaigns from '../../components/Campaigns/Campaigns';
import campaignsRoutes from '../Campaigns/index';
import Orders from '../../components/Orders/Orders';
import Reports from '../../components/Reports/Reports';
import ordersRoutes from '../Orders/index';
import GlobalReport from '../../components/GlobalReport/GlobalReport';
import Properties from '../../components/Properties/Properties';
import Packages from '../../components/Packages/Packages';
import packagesRoutes from '../Packages/index';
import reportRoutes from '../Reports/index';
import OfficeOrderMedia from '../../components/AgencyOrders/OfficeOrders/OrderMedia';
import OfficeOrderDashboard from '../../components/AgencyOrders/OfficeOrders/Dashboard';
import signifiLogRoutes from '../SignifiLogs';
import SignifiLogs from '../../components/Logs/SignifiLogs';
import TestPage from '../../components/AgencyOrders/ReportComponents/TestPage.vue';
import BaseCampaignReportLayout from '../../components/AgencyOrders/Public/BaseCampaignReportLayout.vue';
import AudienceDashboard from '../../pages/audience/index.vue';
import AudienceForm from '../../pages/audience/Form.vue';
import AudienceAdminDashboard from '../../pages/audience/Admin.vue';
import AdminTools from "../../pages/adminTools/index.vue";
import campaignToolRoutes from '../AdminTools';

const routes = [
  {
    path: '/error/:error/:message',
    name: 'error',
    component: Error,
  },
  {
    path: '*',
    redirect: '/404',
  },
  {
    path: '/404',
    component: NotFound,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: ResetPassword,
  },
  {
    path: '/test',
    name: 'test',
    component: TestPage,
  },
  {
    path: '/:campaignId/campaign-report/:token',
    name: 'order-campaign-report',
    component: BaseCampaignReportLayout,
  },
  {
    path: '',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/clients',
        component: Clients,
        children: clientsRoutes,
      },
      {
        path: '/offices/:client?',
        component: Agencies,
        children: agenciesRoutes,
      },
      {
        path: '/packages',
        component: Packages,
        children: packagesRoutes,
      },
      {
        path: '/users',
        component: Users,
        meta: {title: 'Users'},
        children: usersRoutes,
      },
      {
        path: '/signifi-logs/:campaignId?',
        component: SignifiLogs,
        meta: {title: 'Signifi Logs'},
        children: signifiLogRoutes,
      },
      {
        path: '/campaigns',
        component: Campaigns,
        meta: {title: 'Campaigns'},
        children: campaignsRoutes,
      },
      {
        path: '/orders',
        component: Orders,
        meta: {title: 'Orders'},
        children: ordersRoutes,
      },
      {
        path: '/reports',
        component: Reports,
        meta: {title: 'Reports'},
        children: reportRoutes,
      },
      {
        path: '/global-report',
        component: GlobalReport,
        meta: {title: 'GlobalReport'},
      },
      {
        path: '/preferences',
        component: Preferences,
        meta: {title: 'Preferences'},
      },
      {
        path: '/notifications',
        component: Notifications,
        meta: {title: 'Notifications'},
      },
      {
        path: '/office/:agency/campaigns',
        name: 'AgencyOrders',
        component: AgencyOrders,
        meta: {title: 'AgencyOrders'},
      },
      {
        path: '/office/:agency/agent-campaigns/order',
        name: 'AgentOrderMedia',
        component: AgentOrderMedia,
        meta: {title: 'AgentOrderMedia'},
      },
      {
        path: '/office/:agency/agent-campaigns/:campaignId',
        name: 'AgentOrderDashboard',
        component: AgentOrderDashboard,
        meta: {title: 'AgentOrderDashboard'},
      },
      {
        path: '/office/:agency/property-campaigns/order',
        name: 'PropertyOrderMedia',
        component: PropertyOrderMedia,
        meta: {title: 'PropertyOrderMedia'},
      },
      {
        path: '/office/:agency/property-campaigns/:campaignId',
        name: 'PropertyOrderDashboard',
        component: PropertyOrderDashboard,
        meta: {title: 'PropertyOrderDashboard'},
      },
      {
        path: '/office/:agency/office-campaigns/order',
        name: 'OfficeOrderMedia',
        component: OfficeOrderMedia,
        meta: {title: 'OfficeOrderMedia'},
      },
      {
        path: '/office/:agency/office-campaigns/:campaignId',
        name: 'OfficeOrderDashboard',
        component: OfficeOrderDashboard,
        meta: {title: 'OfficeOrderDashboard'},
      },
      {
        path: "/audience",
        name: "AudiencePage",
        component: AudienceDashboard,
        meta: { title: "AudienceList" }
      },
      {
        path: "/audience/form",
        name: "AudienceFormPage",
        component: AudienceForm,
        meta: { title: "AudienceForm" }
      },
      {
        path: "/admin/audience",
        name: "AudienceAdminDashboard",
        component: AudienceAdminDashboard,
        meta: { title: "AudienceAdminDashboard" }
      },
      {
        path: "/admin-tools",
        name: "AdminTools",
        component: AdminTools,
        children: campaignToolRoutes,
        meta: { title: "CampaignDashboard" }
      }
    ],
  },
];

export default routes;
